import { t } from "i18next";
import { getURl } from "services/core";
import ImportForm from "common/components/ImportForm";

const url = `${getURl()}/employee/v1/import_project`;
export default ImportForm({
  title: t("text_import_donor"),
  onBackLink: "/employees",
  titleBeforeUpload: "Are you sure you want to import donor?",
  textBeforeUpload: "This will import the donor for employees. Do you want to continue?",
  textUpload: t("text_upload_a_spreatsheet_to_import_employees_donor"),
  fileName: "Employee Import Employee  Allocated Project Template.xlsx",
  url,
});

